import { useLingui } from "@lingui/react/macro";
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { ChannelDetailsForm } from "~/components/views/app/channel/details-form";
import { getChannelTypeOptions } from "~/models/channel";
import { useTRPC } from "~/trpc/client";

export const Route = createFileRoute("/_app/podcasts/$channelUid/settings/details")({
	component: Page,
	async loader({ context }) {
		context.queryClient.prefetchQuery(context.trpc.parameter.languages.queryOptions());
		context.queryClient.prefetchQuery(context.trpc.parameter.appleCategories.queryOptions());
	},
});

function Page() {
	const { channelUid } = Route.useParams();
	const trpc = useTRPC();
	const { i18n } = useLingui();

	const categoriesQuery = useQuery(trpc.parameter.appleCategories.queryOptions());
	const languagesQuery = useQuery(trpc.parameter.languages.queryOptions());
	const channelQuery = useSuspenseQuery(trpc.channel.find.queryOptions({ channelUid }));

	return (
		<ChannelDetailsForm
			categories={(categoriesQuery.data ?? []).flatMap((category) => [
				{
					value: category.id.toString(),
					label: category.name,
					level: 0,
				},
				...(category.children?.map((child) => ({
					value: child.id.toString(),
					label: child.name,
					search: `${category.name} - ${child.name}`,
					level: 1,
				})) ?? []),
			])}
			channel={channelQuery.data}
			channelTypes={getChannelTypeOptions(i18n)}
			languages={(languagesQuery.data ?? []).map((language) => ({
				value: language.isO2,
				label: `${language.name} - ${language.localName}`,
				search: `${language.name} - ${language.localName}`,
			}))}
		/>
	);
}
